const Coupon = () => {
    return (
        <li>
            <a href="/coupon">特典</a>
        </li>
    );
};

export default Coupon;
